import { render } from "./CasesStudyTwoPage.vue?vue&type=template&id=70ac893b"
import script from "./CasesStudyTwoPage.vue?vue&type=script&lang=js"
export * from "./CasesStudyTwoPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/azai-web/azaitech-website-template-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__